import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { LinkViewModel } from '@/types/B2BcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'CMSLinkHandler',
  props: {
    styleAsButton: { type: Boolean },
    underlineOnHover: { type: Boolean },
    showArrowIcon: { type: Boolean },
    linkBlock: null
  },
  setup(__props: any) {

const props = __props as {
        styleAsButton?: boolean,
        underlineOnHover?: boolean,
        showArrowIcon?: boolean,
        linkBlock: LinkViewModel,
    }



const linkClass = computed(() => {
    return {
        'c-button c-button--current-color inline-block': props.styleAsButton,
        'c-magic-line--underline': !props.styleAsButton && !props.underlineOnHover,
        'c-magic-line': !props.styleAsButton,
    };
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (__props.linkBlock && __props.linkBlock.text)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_RouterLinkConditional, {
          class: _normalizeClass(_unref(linkClass)),
          to: __props.linkBlock.url,
          target: __props.linkBlock.target,
          "spa-enabled": __props.linkBlock.spaLink,
          title: __props.linkBlock.title
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.linkBlock.text), 1)
          ]),
          _: 1
        }, 8, ["class", "to", "target", "spa-enabled", "title"]),
        (!__props.styleAsButton && __props.showArrowIcon)
          ? (_openBlock(), _createBlock(_component_c_icon, {
              key: 0,
              "aria-hidden": "true",
              name: "icon-arrow-small",
              class: "w-8 ml-6"
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})